import { configureStore } from '@reduxjs/toolkit';

import { REDUX_STORAGE_KEY } from '@common/constants';
import { api } from './api';
import user from './user';
import program from './program';
import card from './card';

// @ts-expect-error REDUX_STORAGE_KEY is provided to window by SSR
const _window: typeof globalThis & { [REDUX_STORAGE_KEY]: string } = globalThis || {};
const reducer = {
  user,
  program,
  card,
  [api.reducerPath]: api.reducer,
};

const store = configureStore({
  reducer,
  preloadedState: JSON.parse(_window[REDUX_STORAGE_KEY] || '{}'),
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(api.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export { reducer };
export default store;
